(() => {
  'use strict';
  const pending = new WeakSet();
  async function prepare(event) {
    if (event.type === 'pointerover' && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    if (event.type === 'focusin' && !window.matchMedia('(any-hover: hover)').matches) return;
    const card = event.target.closest?.('.rd3-card');
    const template = card?.querySelector('template[data-rd-card-hover]');
    if (!template || pending.has(template)) return;
    pending.add(template);
    const fragment = template.content.cloneNode(true);
    const image = fragment.querySelector('img');
    if (!image) return;
    image.loading = 'eager';
    image.fetchPriority = 'low';
    image.sizes = `${Math.ceil(template.parentElement.getBoundingClientRect().width)}px`;
    image.style.visibility = 'hidden';
    template.before(fragment);
    try {
      await image.decode();
      image.style.removeProperty('visibility');
      template.remove();
    } catch {
      image.remove();
      pending.delete(template);
    }
  }
  document.addEventListener('pointerover', prepare);
  document.addEventListener('focusin', prepare);
})();
